import * as changeKeys from 'change-case/keys'
import { toDotSnakeCase } from '@utils/toDotSnakeCase'
import { ReportFilter } from '@lib/api'
import { ApiFilter, ReportTypeMap } from '../types'

// Client uses camelCased column accessor keys and filter keys, but API expects snake
export const filterToDotSnakeCase = <RT extends keyof ReportTypeMap>(
  filters: ReportFilter<RT>,
): ApiFilter[] =>
  filters.map(
    (filter) =>
      changeKeys.snakeCase({
        ...filter,
        column: toDotSnakeCase(filter.column),
      }) as ApiFilter,
  )
